import { render, staticRenderFns } from "./DevopsGroup.vue?vue&type=template&id=27684c86&scoped=true&"
import script from "./DevopsGroup.vue?vue&type=script&lang=js&"
export * from "./DevopsGroup.vue?vue&type=script&lang=js&"
import style0 from "./DevopsGroup.vue?vue&type=style&index=0&id=27684c86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27684c86",
  null
  
)

export default component.exports